import TherapiesList from '../components/TherapiesList';
import  '../components/halfMainGallery';

new TherapiesList();